module.exports = __webpack_public_path__ + "static/img/IMG_20160224_140117.e6ec2272.jpg";